import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Answer } from "src/app/classes/dynamic-form";
import { AuthenticationService } from "src/app/services/authentication.service";
import { CalendarService } from "src/app/services/calendar.service";
import { QuestionService } from "src/app/services/question.service";


@Component( {
	selector: "event-registration",
	templateUrl: "./event-registration.component.html",
	styles: [ `
		.errorMessage {
			color: red;
			font-size: 140%;
			font-weight: 500;
			text-align: center;
			padding-bottom: 1em;
			margin-bottom: 1em;
		}
	` ]
})
export class EventRegistrationComponent implements OnInit {


	bInProgress = true;
	categoryId = "";
	eventId = "";
	
	bErrorSubmitting = false;


	constructor(
		private calendarService: CalendarService,
		private activatedRoute: ActivatedRoute,
		private questionService: QuestionService,
		private authenticationService: AuthenticationService,
		private router: Router,
	) {}


	ngOnInit() {
		this.activatedRoute.queryParams.subscribe( params => {

			if( !params['id'] ) {
				alert( "Wrong URL" );
				this.bInProgress = false;
				return;
			}


			this.calendarService.getEventFullInfo( params['id'] ).subscribe( event => {

				this.bInProgress = false;

				if( !event || !event.categoryId ) return;

				this.categoryId = event.categoryId;
				this.eventId = event.id;

			});

		} );

	}

	onSubmit( json: string ) {

		if( this.bInProgress ) return;

		const answer = new Answer();
		answer.ebeId = this.authenticationService.getCurrentUser().ebeId;
		answer.vbAntwort = json;
		answer.veranstaltungId = this.eventId;

		this.bInProgress = true;
		this.bErrorSubmitting = false;
		
		this.questionService.saveAnswers( answer ).subscribe( b1 => {

			if( !b1 ) {
				this.bInProgress = false;
				this.bErrorSubmitting = true;
				return;
			}

			this.calendarService.subscribeToEventWithAnswer( this.eventId ).subscribe( b2 => {

				if( !b2 ) {
					this.bInProgress = false;
					this.bErrorSubmitting = true;
					return;
				}

				const userId = this.authenticationService.getCurrentUser().ebeId;
				this.calendarService.loadSubscribedEvents( userId ).subscribe( {
					next: () => {
						this.bInProgress = false;
						this.bErrorSubmitting = false;
						this.router.navigate( [ 'Veranstaltungen', 'visualisieren' ], { queryParams: { id: this.eventId } } );
					},
					error: () => {
						this.bInProgress = false;
						this.bErrorSubmitting = false;
						this.router.navigate( [ 'Veranstaltungen', 'visualisieren' ], { queryParams: { id: this.eventId } } );
					}
				} );

			});

		});

	}

}

